@if (app.isPlatformBrowser) {
@if (!static) {
<tray-handle />
}
<div class="pos-relative tray-content"
     [class.m-l]="narrow"
     [class.m-r]="narrow">
    <ng-content />
</div>
}